import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { LiveFormsTranslateLoaderService } from '../../../services/live-forms-translate-loader.service';

export interface PhotoPreviewDialogData {
  title: string;
  imageSrc: string;
  imageAlt: string;
  canDelete: boolean;
}

@Component({
  selector: 'lfe-photo-preview-dialog',
  standalone: true,
  imports: [MatDialogTitle, MatDialogContent, MatIconButton, MatIcon],
  templateUrl: './photo-preview-dialog.component.html',
  styleUrl: './photo-preview-dialog.component.css',
  encapsulation: ViewEncapsulation.None
})
export class PhotoPreviewDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<PhotoPreviewDialogComponent>);
  readonly data: PhotoPreviewDialogData = inject(MAT_DIALOG_DATA);
  readonly translateService = inject(LiveFormsTranslateLoaderService);

  onDelete(): void {
    this.dialogRef.close('delete');
  }
}
